import { Action } from '@ngrx/store';

export enum WelcomeActionTypes {
  UpdateSuccessMessage = '[Welcome] Update Success Message',
  UpdateFailureMessage = '[Welcome] Update Failure Message',
}

export class UpdateSuccessMessage implements Action {
  readonly type = WelcomeActionTypes.UpdateSuccessMessage;
  constructor(public payload: { message: string }) {}
}

export class UpdateFailureMessage implements Action {
  readonly type = WelcomeActionTypes.UpdateFailureMessage;
  constructor(public payload: { message: string }) {}
}

export type WelcomeActions = UpdateSuccessMessage | UpdateFailureMessage;
